import React, { useState } from 'react';
import Swal from 'sweetalert2';
import Modal from './Modal';
import { OrderListOrderClazz } from 'types/orderTypes';
import TextArea from '../inputs/TextArea';
import SimpleCheckBox from '../inputs/Checkbox/SimpleCheckbox';
import Fetch from '../../utils/fetch';
import { settings } from '../../settings';

interface SendMessageModalProps {
  orders: OrderListOrderClazz[];
  onCloseModal: () => void;
}

const SendMessageModal = ({ orders, onCloseModal }: SendMessageModalProps) => {
  const [customMessage, setCustomMessage] = useState('');
  const [introTextEnabled, setIntroTextEnabled] = useState(false);
  const [trackingTextEnabled, setTrackingTextEnabled] = useState(false);

  const DEAR_CUSTOMER_TEXT = 'Kjære kunde';
  const TRACKING_TEXT = `Du kan se ordren og oppdatere leveringsinfo eller endre leveringsvindu på sporingssiden: $TRACKING_URL
Hilsen $SERVICE_BRAND`;
  const modalTitle = `Send message to ${orders.length} customer(s)`;
  const grayBlock = {
    backgroundColor: '#F9F9F9',
    padding: '24px',
    borderRadius: '24px',
    fontFamily: 'Helvetica',
    fontWeight: 400,
    fontSize: '16px',
    marginTop: '20px',
  };

  const sendMessage = async () => {
    const url = `${settings.newApiUrl}/sms`;
    const orderIds = orders.map(order => order.id);
    const introText = introTextEnabled ? `${DEAR_CUSTOMER_TEXT}\n` : '';
    const trackingText = trackingTextEnabled ? `\n${TRACKING_TEXT}` : '';
    const message = `${introText}${customMessage}${trackingText}`;
    const body = { orderIds, message };

    // Perform API request
    try {
      const response = await Fetch.post({ url, body });
      if (response.ok) {
        await Swal.fire({
          title: 'Success!',
          text: 'SMS messages sent successfully',
          icon: 'success',
          confirmButtonText: 'Accept',
        });
      } else {
        throw new Error('Something failed, SMS was not sent');
      }
    } catch (error: any) {
      await Swal.fire({
        title: 'Failure!',
        text: error.message,
        icon: 'error',
      });
    } finally {
      onCloseModal();
    }
  };

  const sendButton = {
    title: 'Send',
    type: 'success',
    onClick: () => {
      sendMessage();
    },
    loading: false,
    disabled: false,
  };

  return (
    <Modal
      title={modalTitle}
      onClose={() => onCloseModal()}
      buttons={[sendButton]}
      width={640}
    >
      <div style={{ margin: '14px' }}>
        <div style={{ fontFamily: 'Helvetica', fontSize: '14px' }}>
          Send SMS to customers without changes to orders.
        </div>
        <div style={grayBlock}>
          <SimpleCheckBox
            onChange={() => setIntroTextEnabled(!introTextEnabled)}
            selected={introTextEnabled}
            label={DEAR_CUSTOMER_TEXT}
            labelId="kjæreKundeCheckbox"
          />
          <div style={{ margin: '14px 0px' }}>
            <TextArea
              onChange={event => setCustomMessage(event.target.value)}
              value={customMessage}
              style={{
                fontFamily: 'Helvetica',
                fontSize: '16px',
              }}
            />
          </div>
          <SimpleCheckBox
            onChange={() => setTrackingTextEnabled(!trackingTextEnabled)}
            selected={trackingTextEnabled}
            label={TRACKING_TEXT}
            labelId="trackingCheckbox"
          />
        </div>
      </div>
    </Modal>
  );
};

export default SendMessageModal;
